// import sagas from "./sagas"
import { historySagas } from './History'

export default [
    ...historySagas
]